import { useCallback, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TransactionBlockTab from "components/atoms/TransactionBlockTab";
import TransactionListHead from "components/atoms/TransactionListHead";
import PageTitle from "components/atoms/PageTitle";
import { TRANSACTION_TABS } from "constants/navigation/transactionsMenu";
import TransactionListDepositContainer from "containers/molecules/TransactionListDepositContainer";
import TransactionListWithdrawContainer from "containers/molecules/TransactionListWithdrawContainer";
import classNames from "classnames";
import InviteSortDesktopContainer from "../../../containers/organisms/InviteSortDesktopContainer";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import { makeLangUrl } from "../../../helpers/makeLangUrl";
import useScrollDetection from "../../../hooks/useScrollDetection";

import "./styles.sass";
import url from "../../../url";

const TransactionBlock = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isDesktop } = useBreakpoint();
  const scrollRef = useRef<HTMLDivElement>(null);
  const isScrolled = useScrollDetection(scrollRef);

  const handleTabClick = useCallback(
    (urlLink: string) => {
      navigate(makeLangUrl(urlLink));
    },
    [navigate],
  );

  const handleBack = () => {
    navigate({
      ...(!isDesktop && {
        pathname: url.routes.profile.index(),
      }),
    });
  };

  const currentPath = location.pathname;

  const HeaderClass = classNames("TransactionBlock-header", {
    border: isScrolled,
  });

  return (
    <div className="TransactionBlock">
      <div className={HeaderClass}>
        <div className="TransactionBlock-header__block">
          <PageTitle
            title="menu.left.transactions.history"
            {...(!isDesktop ? { onBack: handleBack } : {})}
          />
          <TransactionBlockTab
            tabs={TRANSACTION_TABS}
            onClick={handleTabClick}
          />
        </div>
        <InviteSortDesktopContainer />
      </div>
      <div className="TransactionBlock__content" ref={scrollRef}>
        <TransactionListHead />
        {currentPath.includes("deposit") && <TransactionListDepositContainer />}
        {currentPath.includes("withdrawal") && (
          <TransactionListWithdrawContainer />
        )}
      </div>
    </div>
  );
};

export default TransactionBlock;
